import { render, staticRenderFns } from "./HeroHome.vue?vue&type=template&id=0278b874"
import script from "./HeroHome.vue?vue&type=script&lang=js"
export * from "./HeroHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports